import ModelModal from '@models/modal'

export default {
  namespaced: true,

  state: {
    modal: null
  },

  getters: {
    isShowModal(state) {
      return !!state.modal
    }
  },

  mutations: {
    setModal(state, value) {
      if (value instanceof ModelModal) {
        state.modal = value
      } else {
        console.warn('model/modalを適用してください')
      }
    },

    removeModal(state) {
      state.modal = null
    }
  },

  actions: {
    showModal({ commit }, modal) {
      commit('setModal', modal)
    },

    hideModal({ commit }) {
      commit('removeModal')
    }
  }
}
